import { useAuth } from '../contexts/AuthContext';
import LoadingSpinner from './LoadingSpinner';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        background: 'var(--color-background)'
      }}>
        <LoadingSpinner size="large" message="Loading..." />
      </div>
    );
  }

  return isAuthenticated ? children : null;
};

export default ProtectedRoute;
